import { PageKeyService } from '@wdpr/ra-angular-page-key';
import { AnalyticsService } from '@wdpr/angular-analytics';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
@Injectable()
export class AnalyticsHandler {

  private _pageKeySub = new Subscription();

    /**
     * Class constructor
     */
    constructor(
        private _pageKeySvc: PageKeyService,
        private _analyticsSvc: AnalyticsService
    ) {}

    /**
     * @desc get Model to trigger get model once page key subscription is done
     * @returns
     */
    public getModel(): Promise<Object> {
      let modelResolve;
      let modelReject;

      // set analytics model to unresolved promise
      const analyticsModel = new Promise((resolve, reject) => {
        modelResolve = resolve;
        modelReject = reject;
      });

      this._pageKeySub = this._pageKeySvc.subscribe(pk => {
        if (pk) {
          this._pageKeySub.unsubscribe();

          // resolve analytics model
          modelResolve(this._analyticsSvc.getModel());
        }
      });

      return analyticsModel;
    }

    public update(): void {
        this._analyticsSvc.update();
    }
}